// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1D6bH","filesListContainer":"PosDisputesFiles_filesListContainer__ndpYn","filesButton":"PosDisputesFiles_filesButton__3Dowv"};